import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setIndicators = (SectorId=null) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Admins/GetIndicatorBySector?SectorId=${SectorId}`).then((res) => {
            let data = res.data;
            var array = [];
            dispatch({type: 'DATA_INDICATOR_DETS', payload: []})
            if (data.IsSuccess) {
                dispatch({type: 'DATA_INDICATORS', payload: data.Data})
            } else {
                dispatch({type: 'DATA_INDICATORS', payload: array})
                if(data.ReturnMessage != "Data Not Found"){
                    Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')    
                }
            }
        })
    }
}

export const setIndicatorDetByIndicator = (IndicatorId=null) => {
    return (dispatch) => {
        http.get(`${URLSVC}/Admins/GetIndicatorDetByIndicator?IndicatorId=${IndicatorId}`).then((res) => {
            let data = res.data;
            var array = [];
            if (data.IsSuccess) {
                dispatch({type: 'DATA_INDICATOR_DETS', payload: data.Data})
            } else {
                dispatch({type: 'DATA_INDICATOR_DETS', payload: array})
                if(data.ReturnMessage != "Data Not Found"){
                    Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')    
                }
            }
        })
    }
}

export const setFormIndicator = (formType, formValue) => {
    return {type: 'FORM_INDICATOR', formType, formValue}
}

export const apiAddUpdateIndicator = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();
        var URL = ``;
        if(iData.Id == null || iData.Id == ""){
            URL = `${URLSVC}/Admins/IndicatorAdd`;
        } else {
            URL = `${URLSVC}/Admins/IndicatorEdit`;
            fd.append('Id', iData.Id);
        }
        fd.append('Name', iData.Name);
        fd.append('Code', iData.Code);
        fd.append('IsBasic', iData.IsBasic);
        fd.append('SectorId', iData.SectorId?.value);
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan indikator`, 'success');
                dispatch({ type: 'MODAL_INDICATOR', payload: false })
                reset();
                dispatch(setIndicators(iData.SectorId?.value))
            } else {
                dispatch({ type: 'MODAL_INDICATOR', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiAddUpdateIndicatorDet = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        console.log("ID NYA ",iData.Id);
        var fd = new FormData();
        var URL = ``;
        if(iData.Id == null || iData.Id == ""){
            URL = `${URLSVC}/Admins/IndicatorDetAdd`;
        } else {
            URL = `${URLSVC}/Admins/IndicatorDetEdit`;
            fd.append('Id', iData.Id);
        }
        fd.append('Name', iData.Name);
        fd.append('Code', iData.Code);
        fd.append('Unit', iData.Unit);
        fd.append('IndicatorId', iData.IndicatorId?.value);
        fd.append('ParentId', iData.ParentId?.value);
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan detil indikator`, 'success');
                dispatch({ type: 'MODAL_INDICATOR_DET', payload: false })
                reset();
                dispatch(setIndicatorDetByIndicator(iData.IndicatorId?.value))
            } else {
                dispatch({ type: 'MODAL_INDICATOR_DET', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiDeleteIndicator = (Id, Nama) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('id', Id);
                http.post(`${URLSVC}/Admins/IndicatorDelete`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Nama})`, 'success')
                        dispatch(setIndicators())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiDeleteIndicatorDet = (Id, Nama,IndicatorId) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus detil data (${Nama})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('id', Id);
                http.post(`${URLSVC}/Admins/IndicatorDetDelete`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus detil data (${Nama})`, 'success')
                        dispatch(setIndicatorDetByIndicator(IndicatorId))
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
